import { navLinks } from '@/mocks/home';
import { useDemoToast } from '@/components/feature/DemoToast';

const quickTopics = ['夜场纪实合集', '深夜录音门', '跟拍机位合集', '往来信件与凭证', '线上痕迹归档'];
const guideItems = ['合集索引怎么看', '如何核对实锤证据', '高清资源下载说明', '素材来源与标注'];

export default function SiteFooter() {
  const { show } = useDemoToast();

  return (
    <footer className="w-full bg-background-200">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-xl"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料吃瓜网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              把黑料吃瓜网视频、图片与实锤证据按合集收好，高清资源支持直接下载，方便你快速找图找视频。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <button
                  key={icon}
                  type="button"
                  onClick={() => show('联系方式仅作展示（演示）')}
                  aria-label="联系方式"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-400/70 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className={`${icon} text-base`}></i>
                </button>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">站内导航</h3>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">热门合集</h3>
            <ul className="mt-4 space-y-3">
              {quickTopics.map((topic) => (
                <li key={topic}>
                  <a
                    href="#index"
                    className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {topic}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">使用说明</h3>
            <ul className="mt-4 space-y-3">
              {guideItems.map((item) => (
                <li key={item}>
                  <a
                    href="#top"
                    className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 rounded-lg border border-background-300/70 bg-background-100 px-5 py-4">
          <p className="text-xs leading-relaxed text-foreground-600">
            网站内容为合集索引与素材整理展示，仅作信息归档参考；涉及他人的内容请依法依规使用，请勿用于任何侵权或不当用途。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 text-xs text-foreground-600 md:flex-row">
          <span>© 2026 黑料吃瓜网 · 合集档案馆</span>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <span className="cursor-pointer transition-colors hover:text-primary-600">服务条款</span>
            <span className="cursor-pointer transition-colors hover:text-primary-600">隐私说明</span>
            <span className="cursor-pointer transition-colors hover:text-primary-600">联系我们</span>
          </div>
        </div>
      </div>
    </footer>
  );
}